export enum Cashflows {
  byCurrency = 'cashflows.byCurrency',
}
